import { Children, Fragment, type ReactNode } from "react";

/**
 * Resúmenes del agente IA: el modelo marca cada cifra con ▲ (ingreso: cobrado, entró, pagado) o
 * ▼ (adeudo: vencido, por cobrar, saldo). Markdown no trae color, así que aquí se pintan el
 * símbolo y el monto que le sigue (hasta el fin del token) en verde o rojo, como en una app
 * financiera. Solo toca strings; los elementos (negritas, enlaces) se dejan a su propio renderer.
 */
const SENTIDO = /([▲▼]\s?[^\s,;)]*)/;

function pintar(texto: string, clave: string): ReactNode {
  if (!texto.includes("▲") && !texto.includes("▼")) return texto;
  return texto.split(SENTIDO).map((parte, i) => {
    if (parte.startsWith("▲")) return <span key={`${clave}-${i}`} className="font-medium text-success">{parte}</span>;
    if (parte.startsWith("▼")) return <span key={`${clave}-${i}`} className="font-medium text-danger">{parte}</span>;
    return <Fragment key={`${clave}-${i}`}>{parte}</Fragment>;
  });
}

export function colorearSentido(children: ReactNode): ReactNode {
  return Children.map(children, (hijo, i) => (typeof hijo === "string" ? pintar(hijo, String(i)) : hijo));
}
